import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appImgOri]'
})
export class ImgOriDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.classifyImage();
  }

  @HostListener('load')
  classifyImage(): void {
      const img: HTMLImageElement = this.el.nativeElement;
      const width = img.naturalWidth;
      const height = img.naturalHeight;
  
      // Remove any previously added classes
      this.renderer.removeClass(img, 'landscape');
      this.renderer.removeClass(img, 'portrait');
      this.renderer.removeClass(img, 'square');
  
      // Classify the image based on its dimensions
      if (width > height) {
        
          this.renderer.addClass(img, 'landscape');
          console.log('Classified as Landscape');
      } else if (height > width) {
          this.renderer.addClass(img, 'portrait');
          console.log('Classified as Portrait');
      } else {
          this.renderer.addClass(img, 'square');
          console.log('Classified as Square');
      }
  }
  

}
